'use client';

import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect } from 'react';
import { overlayStack, type OverlayStackProps } from '@/app/components/overlays/core/overlayStack';
interface useScrollLockProps extends OverlayStackProps {
  enabled: boolean;
}
export const useScrollLock = t0 => {
  const $ = _c(6);
  const {
    overlayKey,
    instanceId,
    enabled,
    lockScroll: t1
  } = t0;
  const lockScroll = t1 === undefined ? true : t1;
  let t2;
  let t3;
  if ($[0] !== enabled || $[1] !== instanceId || $[2] !== lockScroll || $[3] !== overlayKey) {
    t2 = () => {
      const entry = {
        overlayKey,
        instanceId,
        lockScroll
      };
      if (enabled) {
        overlayStack.open(entry);
      } else {
        overlayStack.close({
          overlayKey,
          instanceId
        });
      }
      return () => {
        overlayStack.close({
          overlayKey,
          instanceId
        });
      };
    };
    t3 = [overlayKey, instanceId, enabled, lockScroll];
    $[0] = enabled;
    $[1] = instanceId;
    $[2] = lockScroll;
    $[3] = overlayKey;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useLayoutEffect(t2, t3);
};